module.exports = __webpack_public_path__ + "img/3WYogaRetreat.63a00868.jpeg";